// Named category color palette. The `color` column in the Categories
// Google Sheet can be either a hex value (`#7d2b35`) or one of these
// aliases (`burgundy`, `category-green`, etc.). Aliases let the sheet
// reference the design system without committing to a specific hex,
// so a future palette swap only touches this file.

// Canonical fallback when a category has no color, the lookup misses, or
// a hex value fails sanitisation. Re-exported from `src/data/transform.ts`
// as the public surface; consumers in components/validators import it via
// either path.
export const DEFAULT_CATEGORY_COLOR = '#76849A';

const ALIASES: Record<string, string> = {
  // Brand
  burgundy: '#7d2b35',

  // Category palette — matches --palette-category-* in primitives.css
  'category-pink': '#b85878',
  'category-yellow': '#988020',
  'category-red': '#b04838',
  'category-orange': '#c07040',
  'category-purple': '#7050a0',
  'category-sky': '#4a8a98',
  'category-teal': '#387890',
  'category-green': '#4e9050',
  'category-blue': '#4472a8',
  'category-brown': '#6b4e35',

  // Short aliases (convenience)
  pink: '#b85878',
  yellow: '#988020',
  red: '#b04838',
  orange: '#c07040',
  purple: '#7050a0',
  sky: '#4a8a98',
  teal: '#387890',
  green: '#4e9050',
  blue: '#4472a8',
  brown: '#6b4e35',

  // Legacy aliases kept for backwards compatibility with existing sheets
  rose: '#b85878',
  ochre: '#988020',
  tan: '#c07040',
  'category-rose': '#b85878',
  'category-ochre': '#988020',
  'category-tan': '#c07040',
};

/**
 * Resolve a category color input (hex or named alias) to a concrete hex.
 * Unknown inputs are returned unchanged so legacy sheets keep working.
 */
export function resolveCategoryColor(input: string | undefined | null): string {
  if (!input) return DEFAULT_CATEGORY_COLOR;
  const trimmed = input.trim();
  if (trimmed.startsWith('#')) return trimmed;
  const alias = ALIASES[trimmed.toLowerCase()];
  return alias ?? trimmed;
}
